import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BoxPlotFilledSvg from "@ant-design/icons-svg/es/asn/BoxPlotFilled";
import AntdIcon from "../components/AntdIcon";
var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoxPlotFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BoxPlotFilled.displayName = 'BoxPlotFilled';
}
export default /*#__PURE__*/React.forwardRef(BoxPlotFilled);